import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import {
  HashRouter as Router,
  Route
} from 'react-router-dom';
import App from './components/Main';
import Config from './components/Configuration';
import ArticlesListComponent from './components/ArticlesListComponent';

const sideNav = () => {
  $(".button-collapse").sideNav();
  $(".button-collapse").sideNav('show');
}

ReactDOM.render((
  <Router>
    <div>
      <div className="index">
        <div id="sound"></div>
        <header>
          <nav className="top-nav red darken-3">
            <div className="wrapper-container">
              <div className="nav-wrapper">
                <a className="page-title">Dashboard</a>
                <a onClick={sideNav.bind(this)} data-activates="nav-mobile" className="button-collapse top-nav full hide-on-large-only"><i className="material-icons">menu</i></a>
              </div>
            </div>
          </nav>
        </header>
        <main>
          <Route exact path="/" component={Config} />
          <Route exact path="/:brandId" pageTitle="Dashboard" component={App} />
          <Route exact path="/articles/list" component={ArticlesListComponent} />
        </main>
      </div>
    </div>
  </Router>
), document.getElementById('app'))


// WEBPACK FOOTER //
// ./src/index.js